import backgroundTextureOrchid from 'assets/images/vxl/component/celebrationScreen/background-texture-orchid.png';
import { Stack, useLocalSearchParams, useRouter } from 'expo-router';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ImageSourcePropType, StyleSheet, View } from 'react-native';
import { usePressableAnalytics } from 'shared/hooks/analytics/usePressableAnalytics';
import { useViewDidFocusScreenAnalyticsEvent } from 'shared/hooks/analytics/useViewDidFocusAnalytics';
import { HomeTileTypeIds } from 'shared/hooks/homeTiles/HomeTileTypeIds';
import useRefreshHomeTiles from 'shared/hooks/homeTiles/useRefreshHomeTiles';
import { useBackHandler } from 'shared/hooks/useBackHandler/useBackHandler';
import CelebrationScreen from 'shared/patterns/vxl/CelebrationScreen/CelebrationScreen';
import theme from 'shared/styles/theme';

const CongratsScreen = () => {
  const router = useRouter();
  useViewDidFocusScreenAnalyticsEvent({
    key: 'congratsScreen',
  });

  const { cardId } = useLocalSearchParams<{
    cardId: string;
  }>();

  const { fetching, refreshTiles } = useRefreshHomeTiles([
    HomeTileTypeIds.VXL_CARD_GROUP_TILE_BANKING,
  ]);
  const [shouldNavigate, setShouldNavigate] = useState(false);

  useEffect(() => {
    if (shouldNavigate && !fetching) {
      if (cardId) {
        router.push({
          pathname: '/believe/apply/addWallet',
          params: { cardId },
        });
      } else {
        router.replace('/believe/apply/moneyIn');
      }
      setShouldNavigate(false);
    }
  }, [shouldNavigate, fetching, cardId, router]);

  const backgroundColor = theme.color.expressive.orchid;
  const handleDoneAnalytics = usePressableAnalytics({
    analyticsId: 'done',
  });

  const handleButtonPress = () => {
    handleDoneAnalytics();
    refreshTiles();
    setShouldNavigate(true);
  };

  const { t: translatedText } = useTranslation('believe');

  const backToHome = () => {
    if (router.canGoBack()) {
      router.dismissAll();
    }
    router.back();
  };

  useBackHandler(backToHome);

  return (
    <View style={styles.scrollView}>
      <Stack.Screen
        options={{
          headerShown: false,
          gestureEnabled: false,
        }}
      />
      <CelebrationScreen
        illustrationKey="BELIEVE_APPROVAL_A_ANIMATED"
        illustrationAccessibilityLabel="Application is approved animated illustration"
        bodyText={translatedText('application.applicationSuccess.bodyText')}
        backgroundTexture={backgroundTextureOrchid as ImageSourcePropType}
        backgroundColor={backgroundColor}
        captionText={translatedText(
          'application.applicationSuccess.captionText',
        )}
        button={{
          onPress: () => {
            handleButtonPress();
          },
          label: translatedText('application.button.done'),
          analyticsId: 'done',
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
  },
});

export default CongratsScreen;
